import { MenuItem, SelectChangeEvent } from '@mui/material';
import { CoreTypography } from '@youscience/core';
import { ScholarshipSort, SortDirection } from '@common-types';

import SortByIcon from '@images/sort.svg?react';

import { StyledSortByWrap, StyledSortSelect } from './SortBy.styles';

export interface SortByValues<TSort extends string = ScholarshipSort> {
  sort: TSort;
  sortDirection: SortDirection;
}

export interface SortByOption {
  value: string;
  label: string;
}

interface SortByProps<TSort extends string> {
  sortByValues: SortByValues<TSort>;
  sortByOptions: SortByOption[];
  setSortByFields: (sortByValues: SortByValues<TSort>) => void;
  dataTestId?: string;
}

export const INITIAL_VALUE: SortByValues = { sort: ScholarshipSort.DEADLINE, sortDirection: SortDirection.ASC };

export const SortBy = <TSort extends string = ScholarshipSort>(props: SortByProps<TSort>) => {
  const { sortByValues, sortByOptions, setSortByFields, dataTestId } = props;

  const handleChangeSort = (event: SelectChangeEvent<unknown>) => {
    const [sort, sortDirection] = (event.target.value as string).split(',') as [TSort, SortDirection];

    setSortByFields({ sort, sortDirection });
  };

  return (
    <StyledSortByWrap>
      <SortByIcon />

      <CoreTypography variant="h6" component="h5">
        Sort by:
      </CoreTypography>

      <StyledSortSelect
        data-testid={dataTestId}
        value={`${sortByValues.sort},${sortByValues.sortDirection}`}
        onChange={handleChangeSort}
      >
        {sortByOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </StyledSortSelect>
    </StyledSortByWrap>
  );
};
